/* eslint-disable max-statements */
/* eslint-disable camelcase */
import * as FileSaver from 'file-saver';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { InputSwitch } from 'primereact/inputswitch';
import { InputText } from 'primereact/inputtext';
import { Menu } from 'primereact/menu';
import { Toast } from 'primereact/toast';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

import DisputeNotificationIcon from '../../assets/DisputeNotification.png';
import { useUpdatePayoutExtractStatusMutation } from '../../pages/compensation/compensationSlice';
import { selectCurrentEmpid } from '../../pages/login/authSlice';
import {
    useGetPayoutApprovalsExportQuery,
    useGetPayoutApprovalsQuery,
    useUpdateApprovalStatusMutation,
} from '../../pages/managerDashboard/managerDashboardSlice';
import { formatDate2 } from '../../utils/dateFormat';
import { ConstApprovalStatus, ConstApprovalWindowStatus, monthNames } from '../../utils/typeConstants';
import { AgentStatus } from '../../utils/types';
import { AgentPayoutApprovalDetails } from '../agentPayoutApprovalDetails/AgentPayoutApprovalDetails';
import { useGetScorecardAgentsQuery } from '../scoreCardFilter/scoreCardFilterSlice';
import { DisqualifyApproval } from './DisqualifyApproval';
import { ScoreCardApprovalStatusNotification } from './ScoreCardApprovalStatusNotification';
import { IManagerApproval } from './approval';
import './payoutApprovalsTable.scss';

// eslint-disable-next-line max-statements
export const PayoutApprovalsTable = (props: any) => {
    const toastReact = useRef<Toast>(null);
    const [updatePayoutExtractStatus] = useUpdatePayoutExtractStatusMutation();
    const [UpdateApprovalStatus] = useUpdateApprovalStatusMutation();
    const loggedUserEmpId = useSelector(selectCurrentEmpid);
    const [supervisorNumber, setSupervisorNumber] = useState<any>('0');
    const [inputMonth, setMonth] = useState(null);
    const [inputYear, setYear] = useState(null);
    //const [inputScorecardVersion, setInputScorecardVersion] = useState<any>('');
    const [selectedPayoutApprovals, setSelectedPayoutApprovals] = useState<any>([]);
    const [expandedRows, setExpandedRows] = useState<any>();
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [seletedRowData, setSeletedRowData] = useState<any>([]);
    const [visibleDisqualifyApproval, setvisibleDisqualifyApproval] = useState<boolean>(false);
    const [visibleRemoveDisqualifyApproval, setvisibleRemoveDisqualifyApproval] = useState<boolean>(false);
    const [approvalType, setApprovalType] = useState<any>('');
    const [teamLeadsData, setTeamLeadsData] = useState<any>([]);
    const [exportAfterProcessing, setExportAfterProcessing] = useState<any>(false);
    const [diaApproval, setDiaApproval] = useState(false);
    const [country, setCountry] = useState<any>();
    const [countries, setCountries] = useState<any>([]);
    const [originalPayoutApprovals, setOriginalPayoutApprovals] = useState<any>([]);
    const [payoutApprovalsData, setPayoutApprovalsData] = useState<any>([]);
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        employeeName: {
            operator: FilterOperator.AND,
            constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
        },
    });
    const [orginalExportData, setOrginalExportData] = useState<any>([]);
    const [exportData, setExportData] = useState<any>([]);
    const [inputScorecardRole] = useState<any>();

    const [hideDisqualifyMenu, setHideDisqualifyMenu] = useState(true);
    const [hideRemoveDisqualifyMenu, setHideRemoveDisqualifyMenu] = useState(true);
    const [hideApproveMenu, setHideApproveMenu] = useState(false);
    const [scorecardFilterChecked, setScorecardFilterChecked] = useState<boolean>(false);
    const [inputScorecardVersionOptional, setInputScorecardVersionOptional] = useState<number>(-1);
    const menu = useRef<Menu>(null);
    const items = [];

    type StringNumberTuple = [string, number];

    items.push(
        {
            label: 'Disqualify',
            icon: 'pi pi-pencil',
            visible: !!hideDisqualifyMenu,
            command: () => {
                setvisibleDisqualifyApproval(true);
            },
        },
        {
            label: 'Remove Disqualify',
            icon: 'pi pi-pencil',
            visible: !!hideRemoveDisqualifyMenu,
            command: () => {
                setvisibleRemoveDisqualifyApproval(true);
            },
        },
        {
            label: 'Change Status to Approved',
            icon: 'pi pi-pencil',
            visible: !!hideApproveMenu,
            command: () => {
                setDiaApproval(true);
            },
        }
    );

    const { data: scorecardSupervisorsData } = useGetScorecardAgentsQuery(
        {
            year: inputYear,
            month: inputMonth,
            scorecardVersionId: props?.scorecardversion,
            scorecardRoleId: 2,
            payoutApprover: 1,
        },
        { skip: !inputYear || !inputMonth || !props?.scorecardversion }
    );
    useEffect(() => {
        //alert(props?.scorecardversion+'In payout approvals table');
        setMonth(props?.month);
        setYear(props?.year);
        setInputScorecardVersionOptional(props?.scorecardversion);
        setApprovalType(props?.ApprovalType);
    }, [props]);
    useEffect(() => {
        // alert(inputScorecardVersion);
        if (scorecardFilterChecked) {
            setInputScorecardVersionOptional(0);
            setSupervisorNumber('0');
        } else {
            const scVal =
                props?.scorecardversion === '' || props?.scorecardversion === 0
                    ? -1
                    : props?.scorecardversion;
            setInputScorecardVersionOptional(scVal);
        }
        // alert(inputScorecardVersionOptional);
    }, [scorecardFilterChecked, props?.scorecardversion]);
    const { data: payoutApprovalsDataList } = useGetPayoutApprovalsQuery(
        {
            employeenumber: supervisorNumber,
            year: inputYear,
            month: inputMonth,
            scorecardVersionId: inputScorecardVersionOptional,
            typeOfApproval: approvalType,
            managerNumber: props.isMyReports ? loggedUserEmpId : 0,
            isUnapproved: props.isUnapproved ? 1 : 0,
        },
        {
            skip:
                !supervisorNumber ||
                !inputYear ||
                !inputMonth ||
                !approvalType ||
                inputScorecardVersionOptional < 0,
            // refetchOnMountOrArgChange: true,
        }
    );
    const { data: payoutApprovalsExportData } = useGetPayoutApprovalsExportQuery(
        {
            year: inputYear,
            month: inputMonth,
            scorecardVersionId: props?.scorecardversion,
            scorecardRoleId: inputScorecardRole,
        },
        { skip: !inputYear || !inputMonth || !props?.scorecardversion }
    );

    const dialogFuncMap = {
        diaApproval: setDiaApproval,
    };
    const onHide = () => {
        dialogFuncMap.diaApproval(false);
        closeAll(false);
    };

    const actionTemplate = (rowData: any) => {
        if (
            rowData.overall_status.toLowerCase().includes('approved') ||
            rowData?.overall_status.toLowerCase() === 'disqualified'
        ) {
            return (
                <Button
                    type="button"
                    icon="pi pi-ellipsis-v"
                    onClick={(e: any) => {
                        popupMenuClickHandler(e, rowData);
                    }}
                />
            );
        } else return <div />;
    };

    const popupMenuClickHandler = (e: any, rowData: any) => {
        setSeletedRowData([]);
        setSelectedPayoutApprovals([]);
        if (rowData.overall_status.toLowerCase().includes('approved')) {
            setHideDisqualifyMenu(true);
            setHideRemoveDisqualifyMenu(false);
            setHideApproveMenu(false);
            setSeletedRowData([rowData]);
            //setSeletedRowData([...seletedRowData, rowData]);
        }else {
            setHideDisqualifyMenu(false);
            setHideRemoveDisqualifyMenu(false);
            setHideApproveMenu(true);
            setSelectedPayoutApprovals([rowData]);
            //setSelectedPayoutApprovals([...selectedPayoutApprovals, rowData]);
        }

        if (rowData.overall_status.toLowerCase().includes('disqualified')) {
            setHideDisqualifyMenu(false);
            setHideRemoveDisqualifyMenu(true);
            // setHideApproveMenu(false);
            setSeletedRowData([rowData]);
        } 
        e.preventDefault();
        menu.current?.toggle(e);
    };

    useEffect(() => {
        if (scorecardFilterChecked) setTeamLeadsData([]);
        setOriginalPayoutApprovals([]);
        setPayoutApprovalsData([]);
        if (payoutApprovalsDataList?.data.length > 0) {
            setPayoutApprovalsData(payoutApprovalsDataList);
            setOriginalPayoutApprovals(payoutApprovalsDataList?.data);
            if (exportAfterProcessing === true) {
                if (approvalType === 'Compensation') {
                    const filterdApprovals = payoutApprovalsDataList?.data.filter((ele: any) => {
                        if (country === 'All') return true;
                        return ele.country_name === country;
                    });
                    setPayoutApprovalsData({ data: filterdApprovals });
                }
                setExportAfterProcessing(false);
            } else if (approvalType === 'Compensation') {
                const distCountries = Array.from(
                    new Set(payoutApprovalsDataList.data.map((item: any) => item.country_name))
                );
                distCountries.unshift('All');
                const countriesData = distCountries.map((elem) => ({
                    name: elem,
                    value: elem,
                }));
                setCountries(countriesData);
                setCountry('All');
            }
        }
        else
            setCountries([]);
    }, [scorecardFilterChecked, payoutApprovalsDataList]);
    useEffect(() => {
        if (payoutApprovalsExportData?.data?.length > 0) {
            setExportData(payoutApprovalsExportData?.data.length > 0 ? payoutApprovalsExportData?.data : '');
            setOrginalExportData(
                payoutApprovalsExportData?.data.length > 0 ? payoutApprovalsExportData?.data : ''
            );
        }
    }, [payoutApprovalsExportData]);

    const onGlobalFilterChange = (e: any) => {
        const value = e.target.value;
        const afilters = { ...filters };
        afilters.global.value = value;
        setFilters(afilters);
        setGlobalFilterValue(value);
    };

    const onDisqualifyClicked = () => {
        if (selectedPayoutApprovals.length > 0) {
            setvisibleDisqualifyApproval(true);
            setSeletedRowData(selectedPayoutApprovals);
        } else {
            toastReact.current?.show({
                severity: 'warn',
                summary: 'Error',
                detail: 'Please select Payout for Disqualify',
                life: 3000,
            });
        }
    };
    const accept = () => {
        toastReact.current?.show({
            severity: 'info',
            summary: 'Confirmed',
            detail: 'You have accepted',
            life: 3000,
        });
        onExportForProcessingClicked();
    };

    const reject = () => {
        toastReact.current?.show({
            severity: 'warn',
            summary: 'Rejected',
            detail: 'You have rejected',
            life: 3000,
        });
    };
    const confirm_onExportForProcessingClicked = () => {
        confirmDialog({
            message: 'Are you sure you want to proceed?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept,
            reject,
        });
    };
    const accept1 = () => {
        const payoutApproval = {
            scorecard_version_id: payoutApprovalsData?.data[0]?.scorecard_version_id,
            year: inputYear,
            month: inputMonth,
            approval_status_id: 7,
            emp_monthly_result_id: [],
            all_emp_disqualified: true,
        };
        UpdatePayoutExtractStatus(payoutApproval, '', [], 0);
    };

    const reject1 = () => {        
    };
    const confirm_onExtractForDisqualifiedRecords = () => {
        confirmDialog({
            message: 'No Associates Ready for Export. The approval window will be marked as Closed.\n Are you sure you want to proceed?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept : accept1,
            reject : reject1,
        });
    };
    const onExportForProcessingClicked = () => {
        const monthlyResultIds: number[] = [];
        const arrayScorecardName_Versions: StringNumberTuple[] = [];
        if(!scorecardFilterChecked){
            const allDisqualified = payoutApprovalsData?.data?.every((element:any) => element.approval_status_id === ConstApprovalStatus.DISQUALIFIED);
            if(allDisqualified){
                setTimeout(() => {
                    confirm_onExtractForDisqualifiedRecords();
                  }, 100);
                return;
            }
        }
        payoutApprovalsData?.data?.forEach((element: any) => {
            if (element.approval_status_id === 6) {
                monthlyResultIds.push(element.emp_monthly_result_id);

                arrayScorecardName_Versions.push([element.scorecard_name, element.scorecard_version_id]);
            }
        });

        if (monthlyResultIds.length === 0) {
            toastReact.current?.show({
                severity: 'info',
                detail: 'No Associates Ready for Export',
                life: 3000,
            });
        } else if(scorecardFilterChecked){
                const fileName = country + '_' + inputMonth + '_' + inputYear;
                const payoutApproval = {
                    scorecard_version_id: 0,
                    year: inputYear,
                    month: inputMonth,
                    extract_by: loggedUserEmpId,
                    extract_name: fileName,
                    approval_status_id: 7,
                    emp_monthly_result_id: monthlyResultIds,
                };
                UpdatePayoutExtractStatus(payoutApproval, fileName, monthlyResultIds, 0);
            }
            else {
                const uniqueArrayOfScorecardName_Versions = arrayScorecardName_Versions.filter(
                    (tuple, index, self) =>
                        index === self.findIndex((t) => t[0] === tuple[0] && t[1] === tuple[1])
                );
                uniqueArrayOfScorecardName_Versions.forEach((tuple) => {
                    const fileName = tuple[0] + '_' + inputMonth + '_' + inputYear;
                    const scorecardVersionId = tuple[1];
                    const monthlyResultIdsforScorecardVersion: number[] = [];
                    payoutApprovalsData?.data?.forEach((element: any) => {
                        if (element.approval_status_id === 6 && element.scorecard_version_id === tuple[1]) {
                            monthlyResultIdsforScorecardVersion.push(element.emp_monthly_result_id);
                        }
                    });
                    const payoutApproval = {
                        scorecard_version_id: tuple[1],
                        year: inputYear,
                        month: inputMonth,
                        extract_by: loggedUserEmpId,
                        extract_name: fileName,
                        approval_status_id: 7,
                        emp_monthly_result_id: monthlyResultIdsforScorecardVersion,
                    };
                    UpdatePayoutExtractStatus(payoutApproval, fileName, monthlyResultIds, scorecardVersionId);
                });
            }
    };

    const UpdatePayoutExtractStatus = async (
        payoutApprovals: any,
        exportFileName: string,
        monthlyResultIds: number[],
        scorecardVersionId: number
    ) => {
        updatePayoutExtractStatus(payoutApprovals)
            .unwrap()
            .then(async (response: any) => {
                if (response.data.length > 0) {
                    setExportAfterProcessing(true);
                    await exportExcel(exportFileName, response.data, scorecardVersionId, monthlyResultIds);
                    toastReact.current?.show({
                        severity: 'success',
                        summary: 'Success',
                        detail: `Payout Extract status updated successfully for '${exportFileName}'}`,
                        life: 3000,
                    });
                }
            })
            .then((error: any) => {
                if (error) {
                    toastReact.current?.show({
                        severity: 'error',
                        summary: 'Error',
                        detail: error,
                        life: 3000,
                    });
                }
            });
    };
    const onApprovalClicked = () => {
        if (selectedPayoutApprovals?.length > 0) {
            const approvals = selectedPayoutApprovals.map((item: any) => {
                const approval: IManagerApproval = {
                    approvalComment: '',
                    approveBy: loggedUserEmpId.toString(),
                    empMonthlyResultId: item.emp_monthly_result_id,
                    payoutApprovalActionId: 2,
                    applicationRoleId: 3,
                    approvalStatusId: 5,
                    employeeNumber: `${item.employee_number}`,
                    actionName: 'Manager Approved',
                    month: item.month,
                    year: item.year,
                    scorecardVersionId: props.scorecardversion,
                    approvalWindowStatusId: ConstApprovalWindowStatus.MANAGER_WINDOW,
                };
                return approval;
            });
            UpdateApprovals(approvals);
        } else {
            toastReact.current?.show({
                severity: 'warn',
                summary: 'Error',
                detail: 'Please select Payout for Approve',
                life: 3000,
            });
        }
    };

    const UpdateApprovals = (approvals: any) => {
        const data = {
            approvals,
        };
        UpdateApprovalStatus(data)
            .unwrap()
            .then((res: any) => {
                closeAll(false);
                onHide();
                if (res?.message !== 'Error') {
                    toastReact.current?.show({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Approved',
                        life: 3000,
                    });
                } else {
                    toastReact.current?.show({
                        severity: 'warn',
                        summary: 'Error',
                        detail: 'Approval out of Window',
                        life: 3000,
                    });
                }
            })
            .then((error: any) => {
                console.log(error);
            });
    };

    const closeAll = (isClose: boolean) => {
        setvisibleDisqualifyApproval(isClose);
        setvisibleRemoveDisqualifyApproval(isClose);
        setSeletedRowData([]);
        setSelectedPayoutApprovals([]);
    };
    const onSelectionChange = (event: any) => {
        window.localStorage.unCheckIt = false;
        setSelectedPayoutApprovals(event.value);
    };

    const payoutBodyTemplate = (rowData: any) => {
        // return rowData.payout?.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
        return rowData.payout;
    };

    const dateBodyTemplate = (rowData: any) => {
        const month = rowData?.month;
        const year = rowData?.year;
        // Format the date as "mon-yyyy"
        const formattedDate = `${monthNames[Number(month)]}-${year}`;
        return <span className="image-text">{formattedDate}</span>;
    };

    const overallstatusBodyTemplate = (rowData: any) => {
        const status = rowData?.overall_status;
        let color = '';
        if (status === 'Disqualified') {
            color = 'red';
        } else if (status.toLowerCase().includes('approved')) {
            color = 'green';
        }
        return (
            <span
                className="image-text"
                style={{
                    color,
                }}
            >
                {status}
            </span>
        );
    };

    const allowExpansion = (rowData: any) => {
        if (rowData) return true;
        else return false;
    };
    const rowExpansionTemplate = (rowData: AgentStatus) => {
        return (
            <div className="orders-subtable">
                <AgentPayoutApprovalDetails approvalsData={rowData} />
            </div>
        );
    };

    useEffect(() => {
        setTeamLeadsData([]);
        setOriginalPayoutApprovals([]);
        setPayoutApprovalsData([]);
        setCountries([]);
        if (scorecardSupervisorsData !== undefined && scorecardSupervisorsData?.data.length > 0) {
            const teamLeads = [{ supervisor_number: '0', supervisor_name: 'All' }];
            scorecardSupervisorsData?.data.forEach((element: any) => {
                teamLeads.push(element);
            });
            setTeamLeadsData(teamLeads);
            setOriginalPayoutApprovals([]);
            setPayoutApprovalsData([]);
            setCountries([]);
            setSupervisorNumber('0');
            if (approvalType === 'Compensation') {
                setCountry('All');
            }
        }
    }, [scorecardFilterChecked, scorecardSupervisorsData]);

    const SupervisorOnChange = (e: any) => {
        setSupervisorNumber(e.value);
        if (approvalType === 'Compensation') {
            setCountry('All');
        }
    };
    const onCountryChange = (e: any) => {
        setCountry(e.value);
        const filterdApprovals = originalPayoutApprovals.filter((ele: any) => {
            if (e.value === 'All') return true;
            return ele.country_name === e.value;
        });
        setPayoutApprovalsData({ data: filterdApprovals });

        const filteredExportData = orginalExportData.filter((ele: any) => {
            if (e.value === 'All') return true;
            return ele.country_name === e.value;
        });
        setExportData(filteredExportData);
    };
    const isRowSelectable = (event: any) => {
        return !(
            event.data.overall_status.toLowerCase() === 'disqualified' ||
            event.data.overall_status.toLowerCase() === 'closed' ||
            event.data.overall_status.toLowerCase() === 'ready for extract' ||
            event.data.overall_status.toLowerCase() === 'manager approved'
        );
    };
    function renderValue(value: string | null | undefined) {
        return value !== undefined && value !== null ? value : '';
    }
    const expCompCal = () => {
        const expAge = [{}];

        for (let i = 0; i < exportData.length; i++) {
            const managerData =exportData[i].manager_name !== null ? exportData[i].manager_name.split('(') : '';
            const managerName = managerData?.length > 0 ? managerData[0] : '';
            const managerId = managerData?.length > 1 ? managerData[1]?.split(')')[0] : '';
            const tlData=exportData[i].tl_name !== null ? exportData[i].tl_name.split('(') : '';
            const tlName = tlData?.length > 0 ? tlData[0] : '';
            const tlId = tlData?.length > 1 ? tlData[1]?.split(')')[0] : '';
            const approverTlData=exportData[i].approver_tl_name !== null ? exportData[i].approver_tl_name.split('(') : '';
            const approverTlName = approverTlData?.length > 0 ? approverTlData[0] : '';
            const approverTlId = approverTlData?.length > 1 ? approverTlData[1]?.split(')')[0] : '';
            expAge.push({
                Role_Name: `${exportData[i].employee_role}`,
                Supervisor_Number: tlId,
                Supervisor_Name: tlName,
                Approver_Supervisor_Number: approverTlId,
                Approver_Supervisor_Name: approverTlName,
                Team_Lead_Approval_Status: renderValue(exportData[i].tl_approval_status),
                Oracle_Id: `${exportData[i].employee_number}`,
                Full_Name: `${exportData[i].employee_name}`,
                Associate_Approval_Status: renderValue(exportData[i].agent_approval_status),
                Parent_Client_Name: `${exportData[i].parent_client_name}`,
                Scorecard_Name: `${exportData[i].scorecard_name}`,
                Year: `${exportData[i].year}`,
                Month: `${exportData[i].month}`,
                Total_Metrics_Attained: `${exportData[i].total_metrics_attained}`,
                Total_Metrics_Reported: `${exportData[i].total_metrics_reported}`,
                Payout: `${exportData[i].payout}`,
                Payout_Rule_Name: `${exportData[i].pay_rule_name}`,
                Payout_Tenure_Name: `${exportData[i].payout_tenure_name}`,
                Country_Name: `${exportData[i].country_name}`,
                Geo_Location_Name: `${exportData[i].site_name}`,
                Job_Code: `${exportData[i].job_code}`,
                Job_Title: `${exportData[i].job_title}`,
                Eligibility: `${exportData[i].eligible}`,
                Pay_Basis: `${exportData[i].pay_basis}`,
                Salary: `${exportData[i].pay_rate}`,
                Reg_Hours: `${exportData[i].reg_hours}`,
                OT_Hours: `${exportData[i].ot_hours}`,
                Standard_Work_Hours: renderValue(exportData[i].standard_work_hours),
                Percent_Payout: `${exportData[i].payout_percentage}`,
                Employee_Type: `${exportData[i].employment_type_name}`,
                Corrective_Actions: `${exportData[i].corrective_actions}`,
                Worked_Hours: renderValue(exportData[i].worked_hours),
                Glidepath_Month: renderValue(exportData[i].glidepath_month),
                Total_Associate_Days: renderValue(exportData[i].total_associate_days),
                Manager_Approval_Status: `${exportData[i].manager_approval_status}`,
                Manager_Approval_Date: renderValue(exportData[i].manager_approval_date) !== '' ? formatDate2(exportData[i].manager_approval_date) : '',
                Manager_Number: managerId,
                Manager_Name: managerName,
            });
        }
        return expAge;
    };
    const exportProc = (exportData: any, scorecardVersionId: number, processedResultIds: number[]) => {
        const expAge = [{}];
        for (let i = 0; i < exportData.length; i++) {
            if (processedResultIds.includes(exportData[i].emp_monthly_result_id) && (exportData[i].scorecard_version_id === scorecardVersionId || scorecardVersionId === 0)) {
                const managerData =
                    exportData[i].manager_name !== null ? exportData[i].manager_name.split('(') : '';
                const managerName = managerData?.length > 0 ? managerData[0] : '';
                const managerId = managerData?.length > 1 ? managerData[1]?.split(')')[0] : '';
                const compData =
                    exportData[i].comp_export !== null ? exportData[i].comp_export.split('(') : '';
                const compName = compData?.length > 0 ? compData[0] : '';
                const compId = compData?.length > 1 ? compData[1]?.split(')')[0] : '';
                const exportDate =
                    exportData[i].extract_date !== null ? formatDate2(exportData[i].extract_date) : '';
                const managerDate =
                    exportData[i].manager_approval_date !== null
                        ? formatDate2(exportData[i].manager_approval_date)
                        : '';
                const performancePeriod = `${monthNames[Number(exportData[i].month)]} ${exportData[i].year}`;
                expAge.push({
                    'Country': `${exportData[i].country_name}`,
                    'Geographic Location': `${exportData[i].geo_location_name}`,
                    'Parent Client': `${exportData[i].parent_client_name}`,
                    'Performance Period': performancePeriod,
                    'Scorecard ID': `${exportData[i].scorecard_id}`,
                    'Scorecard Name': `${exportData[i].scorecard_name}`,
                    'Payroll Element': ` `,
                    'Team Lead Approval Status': renderValue(exportData[i].tl_status),
                    'Associate Approval Status': renderValue(exportData[i].agent_status),
                    'Employee ID': `${exportData[i].employee_number}`,
                    'Employee Name': `${exportData[i].employee_name}`,
                    'Employee Role': `${exportData[i].employee_role}`,
                    'Empower Totals': `${exportData[i].payout}`,
                    'Manager Approval Status': renderValue(exportData[i].manager_status),
                    'Manager Name': managerName,
                    'Manager ID': managerId,
                    'Manager Date': managerDate,
                    'Export Date': exportDate,
                    'Export Comp ID': compId,
                    'Export Comp Name': compName,
                });
            }
        }
        return expAge;
    };
    const exportExcel = (exportFilenmae: string, approvalsData: [], scorecardVersionId: number, monthlyresultIds: number[]) => {
        import('xlsx').then((xlsx: any) => {
            const worksheet = xlsx.utils.json_to_sheet(exportProc(approvalsData, scorecardVersionId, monthlyresultIds));
            const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
            const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
            saveAsExcelFile(excelBuffer, exportFilenmae);
        });
    };
    const exportExcelCal = () => {
        import('xlsx').then((xlsx: any) => {
            const worksheet = xlsx.utils.json_to_sheet(expCompCal());
            const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
            const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
            saveAsExcelFile(excelBuffer, 'Payout_Approval_Calculation');
        });
    };
    const exportExcelPayoutApproval = () => {
        import('xlsx').then((xlsx: any) => {
            const worksheet = xlsx.utils.json_to_sheet(payoutApprovalsData?.data);
            const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
            const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
            saveAsExcelFile(excelBuffer, 'Payout_Approval');
        });
    };
    const saveAsExcelFile = (buffer: any, fileName: any) => {
        const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const EXCEL_EXTENSION = '.xlsx';
        const data = new Blob([buffer], {
            type: EXCEL_TYPE,
        });
        FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
    };
    const renderHeader = () => {
        return (
            <div>
                <ConfirmDialog />
                {approvalType === 'Compensation' ? (
                    <div className="row">
                        <div className="col-6">
                            <h4 style={{ float: 'left' }}>Payout Approvals</h4>
                        </div>
                        <div className="col-6">
                            <div className="float-end">
                                <Button
                                    type="button"
                                    icon="pi pi-upload me-2"
                                    className="btn-export mb-3"
                                    data-pr-tooltip="XLS"
                                    onClick={exportExcelCal}
                                >
                                    Export Calculation Details
                                </Button>
                            </div>
                        </div>
                    </div>
                ) : (
                    ''
                )}

                <div className="flex justify-content-between mt-2">
                    <span className="p-input-icon-left" style={{ float: 'left' }}>
                        <i className="pi pi-search" />
                        <InputText
                            value={globalFilterValue}
                            onChange={onGlobalFilterChange}
                            placeholder="Employee Name"
                        />
                    </span>
                    {approvalType === 'Manager' ? (
                        <div className="float-end">
                            <Button
                                disabled={!payoutApprovalsData?.data}
                                type="button"
                                icon="pi pi-upload me-2"
                                className="btn-export me-1"
                                data-pr-tooltip="XLS"
                                label="Export Payout Approval"
                                onClick={exportExcelPayoutApproval}
                            />
                            <Button
                                disabled={!payoutApprovalsData?.data}
                                type="button"
                                className="btn-secondary me-1"
                                label="Disqualify"
                                onClick={onDisqualifyClicked}
                            />
                            <Button
                                disabled={!payoutApprovalsData?.data || selectedPayoutApprovals?.length === 0}
                                type="button"
                                className="btn-primary"
                                label="Approve Payouts"
                                // onClick={onApprovalClicked}
                                onClick={() => setDiaApproval(true)}
                            />
                        </div>
                    ) : (
                        <div className="float-end">
                            <Button
                                type="button"
                                icon="pi pi-upload me-2"
                                className="btn-primary"
                                data-pr-tooltip="XLS"
                                onClick={confirm_onExportForProcessingClicked}
                            >
                                Export for Processing
                            </Button>
                        </div>
                    )}
                </div>
            </div>
        );
    };

    const header = renderHeader();

    const approveDiaFooter = () => {
        return (
            <div className="text-center">
                <Button
                    className="btn-secondary me-3"
                    label="Cancel"
                    onClick={onHide}
                />

                <Button
                    className="btn-primary"
                    label="Yes"
                    onClick={onApprovalClicked}
                />
            </div>
        );
    };

    return (
        <div className="card mt-3 ms-0 me-0 shadow bg-body rounded border-0">
            <div>
                <div className="row" style={{ marginLeft: '0.5rem', marginTop: '0.8rem' }}>
                    <div className="col-2">
                        <p style={{ marginLeft: '0.3rem' }}>Select Team Lead</p>
                        <Dropdown
                            value={supervisorNumber}
                            onChange={SupervisorOnChange}
                            options={teamLeadsData}
                            optionValue={'supervisor_number'}
                            optionLabel={'supervisor_name'}
                            placeholder={'Select Team Lead'}
                            className="custom-dropdown w-200"
                        />
                    </div>

                    {props?.ApprovalType === 'Compensation' ? (
                        <>
                            <div className="col-2">
                                <p style={{ marginLeft: '0.3rem' }}>Select Country</p>
                                <Dropdown
                                    value={country}
                                    onChange={onCountryChange}
                                    options={countries}
                                    optionValue={'name'}
                                    optionLabel={'name'}
                                    placeholder={'Select Country'}
                                    className="custom-dropdown w-200"
                                />
                            </div>
                            <div className="col-2">
                                <p>Remove Scorecard Filter</p>
                                <InputSwitch
                                    checked={scorecardFilterChecked}
                                    onChange={(e) => setScorecardFilterChecked(e.value)}
                                    style={{ marginTop: '0.3rem' }}
                                />
                            </div>
                        </>
                    ) : (
                        <div />
                    )}
                </div>
                <div className="row" style={{ marginLeft: '0.5rem', marginTop: '0.8rem' }}>
                    <div className="col-12 d-flex justify-content-center">
                        <ScoreCardApprovalStatusNotification {...props} />
                    </div>
                </div>
                <hr />
            </div>

            <div className="card-body p-0 align-middle text-center table">
                <Toast ref={toastReact} />
                <Menu model={items} popup ref={menu} id="popup_menu" className="headerFeatures" />
                <DataTable
                    value={payoutApprovalsData?.data}
                    header={header}
                    dataKey="emp_monthly_result_id"
                    className="approvalsTable"
                    selectionMode="single"
                    paginator={
                        payoutApprovalsData?.data?.length > 5 &&
                        (props?.ApprovalType === 'Compensation' || props?.ApprovalType === 'Manager')
                    }
                    rows={5}
                    rowsPerPageOptions={[5, 10, 25, 50, 100]}
                    selection={selectedPayoutApprovals}
                    onSelectionChange={onSelectionChange}
                    scrollable
                    scrollHeight="600px"
                    expandedRows={expandedRows}
                    onRowToggle={(e) => {
                        setExpandedRows(e.data);
                    }}
                    rowExpansionTemplate={rowExpansionTemplate}
                    filters={filters}
                    globalFilterFields={['employee_name']}
                    isDataSelectable={isRowSelectable}
                >
                    {approvalType === 'Manager' ? (
                        <Column
                            selectionMode="multiple"
                            headerStyle={{ width: '10px' }}
                            bodyStyle={{ width: '10px' }}
                        />
                    ) : (
                        <Column hidden />
                    )}
                    <Column header="Name" field="employee_name" sortable sortField="employee_name" />
                    <Column
                        header="Employee ID"
                        field="employee_number"
                        sortable
                        sortField="employee_number"
                    />
                    <Column header="Employee Role" field="employee_role" sortable sortField="employee_role" />
                    <Column
                        header="Overall Status"
                        sortable
                        sortField="overall_status"
                        body={overallstatusBodyTemplate}
                    />
                    <Column header="Performance Period" body={dateBodyTemplate} />
                    <Column header="Empower Totals" body={payoutBodyTemplate} sortable sortField="payout" />
                    {approvalType === 'Compensation' ? (
                        <Column header="Country" sortable field="country_name" sortField="country_name" />
                    ) : (
                        <Column hidden />
                    )}
                    <Column key="expand" expander={allowExpansion} />
                    <Column
                        hidden={approvalType === 'Compensation'}
                        body={actionTemplate}
                        headerStyle={{ width: '1rem', padding: 0 }}
                        style={{ minWidth: '1rem', padding: 0 }}
                    />
                </DataTable>
            </div>
            {(visibleDisqualifyApproval||visibleRemoveDisqualifyApproval) ? (
                <DisqualifyApproval
                    dialogEnable={visibleDisqualifyApproval||visibleRemoveDisqualifyApproval}
                    closeAll={closeAll}
                    seletedRowData={seletedRowData}
                    disqualifyType={visibleDisqualifyApproval===true?'Disqualified': "RemoveDisqualified"}
                />
            ) : (
                ''
            )}
            {diaApproval ? (
                <Dialog
                    visible={diaApproval}
                    style={{ width: '20vw' }}
                    onHide={() => onHide()}
                    footer={approveDiaFooter}
                >
                    <div className="text-center">
                        <div>
                            <img src={DisputeNotificationIcon} alt={DisputeNotificationIcon} />
                        </div>
                        <span style={{ fontSize: '24px', fontWeight: '700', color: '#7D71E2' }}>
                            Status Update
                        </span>
                        <p>Are you sure? you want to change the status to approved?</p>
                    </div>
                </Dialog>
            ) : (
                ''
            )}
        </div>
    );
};
